import React, { useState, useEffect } from 'react';
import { Modal, Select, Table, Button, Form, message,Tooltip,Popconfirm } from 'antd';
import { UserOutlined, TeamOutlined, ApartmentOutlined } from '@ant-design/icons';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { DeleteOutlined, EditOutlined, CopyOutlined } from '@ant-design/icons';

const { Option } = Select;

const TYPE_OPTIONS = [
  { label: 'User', value: 'User', icon: <UserOutlined /> },
  { label: 'Group', value: 'Group', icon: <TeamOutlined /> },
  { label: 'Role', value: 'Role', icon: <ApartmentOutlined /> }
];

const ACCESS_LEVELS = [
  { label: 'Read Only', value: 'read' },
  { label: 'Read/Write', value: 'write' }
];

const ManualShareRecordModal = ({ open, onClose, onSave, initialData = [],objectName,recordId,userId }) => {
  const [form] = Form.useForm();
  const [selectedAccess, setSelectedAccess] = useState('read');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [roles, setRoles] = useState([]);

  const [sharedList, setSharedList] = useState(initialData);

  // useEffect(() => {
  //   if (open) {
  //     setSharedList(initialData || []);
  //     form.resetFields();
  //   }
  //   getUsers();
  //   getGroups();
  //   getRoles();
  // }, [open]);

  useEffect(() => {
    if (open) {
      console.log('initial data in the manual comp..',initialData);
      const transformed = (initialData || []).flatMap(entry => {
        const access = entry.access_level || 'read';
  
        const users = (entry.shared_with_users || []).map(u => ({
          _id: u.id,
          Name: u.name,
          type: 'User',
          access
        }));
  
        const roles = (entry.shared_with_roles || []).map(r => ({
          _id: r.id,
          Name: r.name,
          type: 'Role',
          access
        }));
  
        const groups = (entry.shared_with_groups || []).map(g => ({
          _id: g.id,
          Name: g.name,
          type: 'Group',
          access
        }));
  
        return [...users, ...roles, ...groups];
      });
      console.log('shared initial list ::',transformed);
      setSharedList(transformed);
      form.resetFields();
    }
  
    getUsers();
    getGroups();
    getRoles();
  }, [open]);
  
  const getUsers = async () => {
    try {
      const apiService = new ApiService(`${BASE_URL}/fetch_records/User`, { "Content-Type": "application/json" }, "GET");
      const response = await apiService.makeCall();
      setUsers(response.records || []);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const getGroups = async () => {
    try {
      const apiService = new ApiService(`${BASE_URL}/get_all_groups`, { "Content-Type": "application/json" }, "GET");
      const response = await apiService.makeCall();
      setGroups(response.groups || []);
    } catch (err) {
      console.error('Error fetching groups:', err);
    }
  };

  const getRoles = async () => {
    try {
      const apiService = new ApiService(`${BASE_URL}/get_all_user_role`, { "Content-Type": "application/json" }, "GET");
      const response = await apiService.makeCall();
      setRoles(response || []);
    } catch (err) {
      console.error('Error fetching roles:', err);
    }
  };

  const handleAdd = () => {
    const allNewItems = [];

    const types = [
      { list: users, selected: selectedUsers, type: 'User' },
      { list: groups, selected: selectedGroups, type: 'Group' },
      { list: roles, selected: selectedRoles, type: 'Role' }
    ];

    types.forEach(({ list, selected, type }) => {
      selected.forEach(id => {
        const item = list.find(i => i._id === id);
        if (item && !sharedList.find(existing => existing._id === id)) {
          allNewItems.push({ ...item, type, access: selectedAccess });
        }
      });
    });

    if (!allNewItems.length) {
      message.info('All selected items are already added.');
      return;
    }

    setSharedList([...sharedList, ...allNewItems]);
    setSelectedUsers([]);
    setSelectedGroups([]);
    setSelectedRoles([]);
  };

  const handleRemove = (id) => {
    console.log('id to remove is ::',id);
    setSharedList(sharedList.filter(item => item._id !== id));
  };

  const handleSubmit = () => {
    console.log('shared list in the submit ',sharedList);
    const payload = {
      manual_share: {
        object_name: objectName,
        record_id: recordId,
        shared_with_user_ids: sharedList.filter(i => i.type === 'User').map(i => i._id),
        shared_with_group_ids: sharedList.filter(i => i.type === 'Group').map(i => i._id),
        shared_with_role_ids: sharedList.filter(i => i.type === 'Role').map(i => i._id),
        shared_with_role_subordinate_ids: [], // you can modify this if needed
        access_level: sharedList[0]?.access || 'read'
      }
    };
  
    onSave(payload);
    onClose();
  };
  

  const columns = [
    { title: 'Name', dataIndex: 'Name' },
    { title: 'Type', dataIndex: 'type' },
    {
      title: 'Access Level',
      dataIndex: 'access',
      render: (text) => (text === 'write' ? 'Read/Write' : 'Read Only')
    },
    {
      title: '',
      render: (_, record) => (
        <Tooltip title="Delete">
        <Popconfirm
            title="Are you sure you want to remove this access?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => handleRemove(record._id)}
        >
            <DeleteOutlined
                style={{ color: 'red', marginRight: 8, fontSize: '14px', cursor: 'pointer' }}
            />
        </Popconfirm>
    </Tooltip>
        // <Button type="link" danger onClick={() => handleRemove(record._id)}>Remove</Button>
      )
    }
  ];

  return (
    <Modal title="Share Record" open={open} onCancel={onClose} onOk={handleSubmit} zIndex={1002} okText="Save">
      <Form form={form} layout="vertical">
        <Form.Item label="Select Users">
          <Select
            mode="multiple"
            value={selectedUsers}
            onChange={setSelectedUsers}
            style={{ width: '100%' }}
            placeholder="Select Users"
            showSearch
            optionFilterProp="children"
          >
            {users
              .filter(user => !sharedList.find(item => item._id === user._id && item.type === 'User'))
              .map(user => (
                <Option key={user._id} value={user._id}>
                  {user.Name}
                </Option>
            ))}

          </Select>
        </Form.Item>

        <Form.Item label="Select Groups">
          <Select
            mode="multiple"
            value={selectedGroups}
            onChange={setSelectedGroups}
            style={{ width: '100%' }}
            placeholder="Select Groups"
            showSearch
            optionFilterProp="children"
          >
            {groups
              .filter(group => !sharedList.find(item => item._id === group._id && item.type === 'Group'))
              .map(group => (
                <Option key={group._id} value={group._id}>
                  {group.Name}
                </Option>
            ))}

          </Select>
        </Form.Item>

        <Form.Item label="Select Roles">
          <Select
            mode="multiple"
            value={selectedRoles}
            onChange={setSelectedRoles}
            style={{ width: '100%' }}
            placeholder="Select Roles"
            showSearch
            optionFilterProp="children"
          >
            {roles
              .filter(role => !sharedList.find(item => item._id === role._id && item.type === 'Role'))
              .map(role => (
                <Option key={role._id} value={role._id}>
                  {role.Name}
                </Option>
            ))}

          </Select>
        </Form.Item>

        <Form.Item label="Access Level">
          <Select value={selectedAccess} onChange={setSelectedAccess} style={{ width: '100%' }}>
            {ACCESS_LEVELS.map(level => (
              <Option key={level.value} value={level.value}>
                {level.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Button type="primary" onClick={handleAdd}>Add</Button>
      </Form>

      <Table
        style={{ marginTop: 20 }}
        dataSource={sharedList}
        columns={columns}
        rowKey="_id"
        pagination={false}
        scroll={{ y: 200 }}
      />
    </Modal>
  );
};

export default ManualShareRecordModal;
